import React from 'react';

/**
 * Honest announcement bar: no fake timers or counters, and never the price (Tomás rule 2026-10-23).
 */
export function CountdownBar() {
  return <div className="sticky top-0 z-50 w-full border-b border-white/10 bg-slate-900 text-stone-50" data-id="element-59" data-mp="306k0ohz7h96a">
      <div className="mx-auto flex max-w-6xl items-center justify-center gap-x-3 whitespace-nowrap px-4 py-2.5 text-xs sm:text-sm" data-id="element-60" data-mp="2vcz2opxm4f73">
        <span className="relative flex h-2 w-2 shrink-0" aria-hidden="true" data-id="element-61" data-mp="2me3y1ia7vd5w">
          <span className="relative inline-flex h-2 w-2 rounded-full bg-red-300" data-id="element-62" data-mp="2mc0xi4bfu1mx" />
        </span>
        <span className="font-semibold text-stone-50" data-id="element-63" data-mp="2hhn8qkra6sr8">Instant PDF download</span>
        <span className="text-stone-50/80" data-id="element-64" data-mp="2cghg0mxmf5hp">· One-time payment<span className="hidden sm:inline" data-id="element-65" data-mp="28f45hzjl2e4g"> · 7-day money-back guarantee</span></span>
      </div>
    </div>;
}